"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8046],{

/***/ 8046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M3 4h18c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-1v6c0 2.3-2.2 6-8 6s-8-3.7-8-6V9H3c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1zm9 15c4.4 0 6-2.5 6-4V9H6v6c0 1.5 1.6 4 6 4zm7-12h1V6H4v1h15zM9 15c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3zm3 1c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1s-1 .4-1 1v3c0 .6.4 1 1 1zm5-1c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3z"
}), "SmokeDetector"));


/***/ })

}]);